export const HEADING = 'Product Information';
export const BANNER_ASPECT_RATION = 1.99;
export const VIEW_MORE_INFO = 'View More';
